import { render, staticRenderFns } from "./UpperDisplay.vue?vue&type=template&id=023e099a&"
import script from "./UpperDisplay.vue?vue&type=script&lang=js&"
export * from "./UpperDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports